import '../css/googlebutton.css'
import {useState} from 'react'

export const GoogleButton = ({props} ) => {
  const { onClick, buttonIsEnabled } = props;
  const [buttonStyle, setButtonStyle] = useState("google-normal");
  
  const onMouseDown = () => {
    if ( buttonIsEnabled) {
      setButtonStyle("google-pressed");
    }
  }

  const onMouseUp = () => {
    if ( buttonIsEnabled) {
      setButtonStyle("google-normal");
      onClick();
    }
  }
  const onMouseEnter = () => {
    if ( buttonIsEnabled) {
      setButtonStyle("google-focus");
    }
  }
  const onMouseLeave = () => {
    if ( buttonIsEnabled) {
      setButtonStyle("google-normal");
    }
  }


  return (
    <>
    <div className={"google " + ( (! buttonIsEnabled ) ? "google-normal" : buttonStyle)} onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter} onMouseDown={onMouseDown} onMouseUp={onMouseUp}>
    </div>
    </>
  )
}

export default GoogleButton;
